import { NgModule } from '@angular/core';
import { FbqGgCartPageEventBuilder } from './fbq-gg-cart-page-event.builder';

@NgModule({})
export class FbqGgCartPageEventModule {
  constructor(_fbqGgCartPageEventBuilder: FbqGgCartPageEventBuilder) {}
}
